import React from 'react';
import { FontIcon, RaisedButton, CircularProgress, FlatButton, Card, CardText, CardHeader } from 'material-ui';
import SelectTemplates from '../create-template-draft/components/select-template';
import R from 'ramda';
import moment from 'moment';

const TemplatesByLocationsForGroupWizard = ({
  templates,
  updateProps,
  selectedTemplatesForGroup,
  loadingForGroupWizard,
}) => {
  if (loadingForGroupWizard) {
    return (<div style={{ margin: '16px 0', paddingBottom: '8px', borderBottom: '1px solid #e0e0e0' }}>
      <CircularProgress style={{ margin: 'auto' }} />
    </div>);
  }
  return (
    <div>
      <div style={{ margin: '16px 0', paddingBottom: '8px', borderBottom: '1px solid #e0e0e0' }}>
        {
          !selectedTemplatesForGroup.length ? <b style={{ marginBottom: '16px' }}>Please select templates: </b>
            : (<div style={{ marginBottom: '16px', fontWeight: 'bold' }}>Templates included in this group:</div>)
        }
        {
          selectedTemplatesForGroup.map(({ _id, templateName, locationName }, i) => (
            <div key={`${i}${templateName}`} style={{ display: 'flex', alignItems: 'center', color: 'rgba(0, 0, 0, 0.54)', justifyContent: 'space-between' }}>
              <div style={{ height: '40px', display: 'flex', alignItems: 'center' }}>
                <FontIcon className="tc-icon-description" color="rgba(0, 0, 0, 0.54)" />
                <div>
                  {locationName}
                  <small style={{ paddingLeft: '2px' }}>({templateName})</small>
                </div>
              </div>
              <RaisedButton
                style={{ marginRight: '2px' }}
                label="remove"
                labelStyle={{ color: '#ff4081' }}
                onTouchTap={() => updateProps({ selectedTemplatesForGroup: R.reject(R.propEq('_id', _id), selectedTemplatesForGroup) })}
              />
            </div>
          ))
        }
      </div>
      <div style={{ marginBottom: '16px', fontWeight: 'bold' }}>{templates.length && selectedTemplatesForGroup.length ? 'Additional templates you can add to the group:' : ''}</div>
      {
        !templates.length
          ? `You don't have templates available for this period.`
          : (
            <SelectTemplates
              templates={templates}
              selectedTemplates={selectedTemplatesForGroup}
              label="Add To Group"
              selectedComponent={<div style={{ width: '68px' }}>Added</div>}
              onConfirm={template => updateProps({ selectedTemplatesForGroup: R.append(template, selectedTemplatesForGroup) })}
            />
          )
      }
    </div>
  );
};

export default TemplatesByLocationsForGroupWizard;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-group/step-two-templates.jsx